<div id="alert-container" *ngIf="alerts.length > 0">
  <div *ngFor="let alert of alerts" class="alert" [ngClass]="alert.type">
    {{ alert.message }}
  </div>
</div>